var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialYt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Youtube",
    width: 26,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.62 1.049S17.186 0 13 0C8.814 0 3.38 1.049 3.38 1.049L0 5V17.001l3.38 3.951s5.434 1.049 9.62 1.049c4.186 0 9.62-1.049 9.62-1.049L26 17.001V11 5l-3.38-3.951zM10 15.601V6.399L18 11l-8 4.601z",
    fill: "#E84344"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 1a4 4 0 100 8 4 4 0 000-8zm0 12a4 4 0 100 8 4 4 0 000-8zM0 5a4 4 0 004 4c2.209 0 3-1.791 3-4s-.791-4-3-4a4 4 0 00-4 4zm4 8a4 4 0 100 8 4 4 0 000-8z",
    fill: "#E84344"
  })));
}
export default SvgSocialYt;